import React from 'react';

export default ({ color }) => (
  <svg width="100%" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.04463 16.4069H5.75655V6.37283H3.04463V16.4069ZM4.40059 1.94336C3.49662 1.94336 2.77344 2.66654 2.77344 3.57051C2.77344 4.47448 3.49662 5.19766 4.40059 5.19766C5.30456 5.19766 6.02774 4.47448 6.02774 3.57051C6.02774 2.66654 5.30456 1.94336 4.40059 1.94336ZM10.3668 7.90958V6.37283H7.65489V16.4069H10.3668V11.2543C10.3668 8.36157 14.0731 8.18078 14.0731 11.2543V16.4069H16.785V10.2599C16.785 5.37846 11.6324 5.55925 10.3668 7.90958Z" style={{ fill: `var(--social-icon-color, ${color || 'black'})` }} />
  </svg>
);
